const path = `clientprofiles`;

export const state = {
	clientList: null,
};

export const getters = {
	clientList: (state) => (state.clientList ? state.clientList : []),
};

export const mutations = {
	clientList: (state, clientList) => (state.clientList = clientList),
};

export const actions = {
	[`getAllSimple`]() {
		return new Promise((resolve, reject) => {
			this._vm.$http.get(`/${path}`)
			.then((response) => {
				response.data = response.data || []
				const simpleData = response.data.map(client =>{
					return { 
						id: client.id,
						credits: client.credits,
						username : client.user.username
					}
				})
				resolve(simpleData);
			})
			.catch(reject)
		});
	},

	// --- Generic Methods
	[`getAll`]() {
		return this._vm.$http.get(`/${path}`);
	},
	[`get`](store, { id }) {
		return this._vm.$http.get(`/${path}/${id}`);
	},
	[`create`](store, data) {
		return this._vm.$http.post(`/${path}`, data);
	},
	[`update`](store, { id, data }) {
		return this._vm.$http.put(`/${path}/${id}`, data);
	},
	[`delete`](store, { id }) {
		return this._vm.$http.delete(`/${path}/${id}`);
	},
	[`deleteAll`]() {
		return this._vm.$http.delete(`/${path}`);
	},
};
